// GTM utility functions for tracking events
import posthog from "posthog-js";

interface IGTMEvent {
  event: string;
  [key: string]: string | number | boolean | null | undefined;
}

interface IGTMWindow {
  dataLayer?: IGTMEvent[];
  gtag?: (command: string, eventName: string, params?: Record<string, unknown>) => void;
}

/**
 * Push an event to the Google Tag Manager data layer
 * @param event The event object to push to the data layer
 */
export function pushGTMEvent(event: IGTMEvent): void {
  if (typeof window !== "undefined") {
    const dataLayer = (window as unknown as IGTMWindow).dataLayer || [];
    dataLayer.push(event);
    (window as unknown as IGTMWindow).dataLayer = dataLayer;
    console.log("GTM Event pushed:", event);
  }
}

export function pushAdConversion(id: string): void {
  if (typeof window !== "undefined") {
    (window as unknown as IGTMWindow).gtag?.("event", "conversion", { send_to: id });
    console.log("Google Ad Converion Sent.");
  }
}

/**
 * Track an event in PostHog
 * @param eventName The name of the event
 * @param properties Event properties
 */
export function trackPostHogEvent(
  eventName: string,
  properties?: Record<string, string | number | boolean | null | undefined>
): void {
  if (typeof window !== "undefined" && posthog) {
    posthog.capture(eventName, properties);
    console.log("PostHog Event captured:", eventName, properties);
  }
}

/**
 * Track a user signup event in both GTM and PostHog
 * @param userData User data to include with the event
 */
export function trackUserSignup(userData?: { email?: string; name?: string }): void {
  const eventProperties = {
    userEmail: userData?.email || "",
    userName: userData?.name || "",
    signupDate: new Date().toISOString()
  };

  // Track in GTM
  pushGTMEvent({
    event: "userSignup",
    ...eventProperties
  });

  pushAdConversion("AW-16575997839/FYP2CIPv67caEI_PhuA9");

  // Track in PostHog
  trackPostHogEvent("user_signup", eventProperties);
}

export function trackUserRegister(userData?: { email?: string; name?: string }): void {
  const eventProperties = {
    userEmail: userData?.email || "",
    userName: userData?.name || "",
    signupDate: new Date().toISOString()
  };

  // Track in GTM
  pushGTMEvent({
    event: "userRegister",
    ...eventProperties
  });

  pushAdConversion("AW-16575997839/9cLtCIDv67caEI_PhuA9");

  // Track in PostHog
  trackPostHogEvent("user_register", eventProperties);
}
